import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';

import { Button, Grid, Typography, Box } from '@material-ui/core';
import { CreateOutlined as CreateOutlinedIcon } from '@material-ui/icons';

import ClassCardItem from './ClassCardItem/ClassCardItem';
import ModalForm from './Modals/ModalForm';
import JoinClassForm from './Modals/JoinClassForm';

import { StateContext, DispatchContext } from '../../../context/Provider';

import JoinClassRequests from './Modals/JoinClassRequests';

import FacultyList from './FacultyList/FacultyList'

const Dashboard = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState, globalState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [open, setOpen] = useState(false);
    const [openJoinClassForm, setOpenJoinClassForm] = useState(false);

    const [facultyFilter, setFacultyFilter] = useState(null);

    const handleOpenModal = () => {
        setOpen(true);
        facultyDispatch({type: 'setDialogTitle', value: 'Create Class'});
        facultyDispatch({type: 'setClassesClassID', value: null});
        // facultyDispatch({type: 'setClassesOpenDialog', value: true});
    }

    const handleClose = () => {
        setOpen(false);
        // facultyDispatch({type: 'setClassesOpenDialog', value: false});
    }

    const handleOpenJoinClassForm = () => {
        setOpenJoinClassForm(true);
        facultyDispatch({type: 'setDialogTitle', value: 'Join Class'});
    }

    const handleCloseJoinClassForm = () => {
        setOpenJoinClassForm(false);
    }

    const [showArchived, setShowArchived] = useState(false)
    let classStatus = 'active'
    async function fetchClassrooms(classStatus = 'active') {
        try {
            globalDispatch({type: 'setIsLoading', value: true});

            const response = await axiosConfig.get(`/classrooms?classStatus=${classStatus}`);
            const { data } = response.data;

            const classroomsArr = [];
            data.map(function (data, index) {
                classroomsArr.push(data);
            });

            getAllClassroomRequests();

            globalDispatch({type: "setClassrooms", data: classroomsArr});

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const [classroomRequests, setClassroomRequests] = useState([])
    const getAllClassroomRequests = async () => {
        const response = await axiosConfig.get('/student-requests/1');

        if (response.data.status_code === 'ok') {
            setClassroomRequests(response.data.requests);
        }
    }

    const getFilteredClassrooms = () => {
        if (!facultyFilter) return []

        return globalState.classrooms.filter((classroom) => {
            return classroom.faculty_id === facultyFilter
        })
    }

    const getUniqueFaculties = () => {
        let classrooms = globalState.classrooms
        if (!classrooms) {
        return []
        }

        let uniqueFacultyIds = []
        let uniqueFaculties = []

        classrooms.filter((classroom) => {
            let uniqueFacultyCheck = uniqueFacultyIds.includes(classroom.faculty_id)

            if (!uniqueFacultyCheck) {
                uniqueFacultyIds.push(classroom.faculty_id)
                uniqueFaculties.push(classroom)
            }

            return uniqueFacultyCheck;
        })

        return uniqueFaculties;
    }

    useEffect(() => {

        globalDispatch({type: 'setShowTabs', value: false});
        globalDispatch({type: 'setIsLoading', value: true});
        const source = axiosConfig.CancelToken.source();

        fetchClassrooms();

        // cleanup.. will run before component is removed from UI
        return () => {
            source.cancel();
        }

    }, []);

    const CreateClassBtn = () => (
        <Button
            color="primary"
            variant="outlined"
            size="medium"
            startIcon={<CreateOutlinedIcon />}
            onClick={handleOpenModal}
            disableRipple
            style={{marginRight: '10px'}}
        >
            Create Class
        </Button>
    );

    const JoinClassBtn = () => (
        <Button
            color="primary"
            variant="outlined"
            size="medium"
            startIcon={<CreateOutlinedIcon />}
            onClick={handleOpenJoinClassForm}
            disableRipple
            style={{marginRight: '10px'}}
        >
            Join Class
        </Button>
    );

    const ArchivedClassroomBtn = () => {
        return (
            <Button
                color="primary"
                variant="outlined"
                size="medium"
                disableRipple
                onClick={() => {
                    classStatus = 'archived'
                    setShowArchived(true)
                    fetchClassrooms('archived')
                }}
                style={{marginRight: '10px'}}
            >
                View Classroom Archive
            </Button>
        )
    }

    const ActiveClassroomBtn = () => {
        return (
            <Button
                color="primary"
                variant="outlined"
                size="medium"
                disableRipple
                onClick={() => {
                    classStatus = 'active'
                    setShowArchived(false)
                    fetchClassrooms('active')
                }}
                style={{marginRight: '10px'}}
            >
                View Active Classrooms
            </Button>
        )
    }

    return (
        <ResponsiveLayout>
            <Grid container spacing={2}>

                {authState.user.role_id === 3 && facultyFilter === null && <Grid item xs={12}>
                    { open ? (
                        <ModalForm
                            open={open}
                            handleClose={handleClose}
                            dialogTitle={`Create Class`}
                            classID={null}
                            fetchClassrooms={fetchClassrooms}
                            classrooms={getUniqueFaculties()}
                        /> ) : null
                    }

                    <Box marginBottom={2}>
                        <Typography variant="h5">All Faculties</Typography>
                    </Box>
                    <FacultyList
                        key={`faculty-list`}
                        classrooms={getUniqueFaculties()}
                        facultySelected={(selectedFaculty) => setFacultyFilter(selectedFaculty)}
                        createClass={() => handleOpenModal()}
                    />
                </Grid>}

                {authState.user.role_id === 3 && facultyFilter !== null && <>

                    { openJoinClassForm ? (
                        <JoinClassForm
                            open={openJoinClassForm}
                            handleClose={handleCloseJoinClassForm}
                            dialogTitle={`Join Class`}
                            fetchClassrooms={fetchClassrooms}
                        /> ) : null
                    }

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button
                            color="primary"
                            variant="outlined"
                            size="medium"
                            onClick={() => setFacultyFilter(null)}
                            disableRipple
                            style={{marginRight: '10px'}}
                        >
                            <i className="fa fa-arrow-left"></i> &nbsp; Faculty List
                        </Button>

                        { authState.user.role_id === 4 ? (<CreateClassBtn />) : null }
                        { authState.user.role_id === 5 ? (<JoinClassBtn />) : null }
                        { authState.user.role_id === 5 && <JoinClassRequests requestCancelled={getAllClassroomRequests} classroomRequests={classroomRequests} /> }
                        { (authState.user.role_id === 3 || authState.user.role_id === 4) ? (showArchived) ? <ActiveClassroomBtn /> : <ArchivedClassroomBtn /> : null }
                    </Grid>

                    {getFilteredClassrooms().map((data, i) => (
                        <ClassCardItem
                            key={i}
                            avatarPlaceholder={data.avatar}
                            classID={data.id}
                            className={data.name}
                            classCode={data.class_code}
                            section={data.section}
                            themeColor={data.theme_color}
                            facultyName={data.faculty_name}
                            isArchived={data.is_archived}
                            fetchClassrooms={fetchClassrooms}
                        />
                    ))}
                </>}

                {/* Dashboard for non subject coordinator */}
                {authState.user.role_id !== 3 && <>
                    { open ? (
                        <ModalForm
                            open={open}
                            handleClose={handleClose}
                            dialogTitle={`Create Class`}
                            classID={null}
                            fetchClassrooms={fetchClassrooms}
                        /> ) : null
                    }

                    { openJoinClassForm ? (
                        <JoinClassForm
                            open={openJoinClassForm}
                            handleClose={handleCloseJoinClassForm}
                            dialogTitle={`Join Class`}
                            fetchClassrooms={fetchClassrooms}
                        /> ) : null
                    }

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        { authState.user.role_id === 4 ? (<CreateClassBtn />) : null }
                        { authState.user.role_id === 5 ? (<JoinClassBtn />) : null }
                        { authState.user.role_id === 5 && <JoinClassRequests requestCancelled={getAllClassroomRequests} classroomRequests={classroomRequests} /> }
                        { (authState.user.role_id === 3 || authState.user.role_id === 4) ? (showArchived) ? <ActiveClassroomBtn /> : <ArchivedClassroomBtn /> : null }
                    </Grid>

                    {globalState.classrooms.map((data, i) => (
                        <ClassCardItem
                            key={i}
                            avatarPlaceholder={data.avatar}
                            classID={data.id}
                            className={data.name}
                            classCode={data.class_code}
                            section={data.section}
                            themeColor={data.theme_color}
                            facultyName={data.faculty_name}
                            isArchived={data.is_archived}
                            fetchClassrooms={fetchClassrooms}
                        />
                    ))}
                </>}
            </Grid>
        </ResponsiveLayout>
    );
}

export default Dashboard;